import { Model } from "@datx/core";
import { jsonapi } from "@datx/jsonapi";

export default class Survey extends jsonapi(Model) {
  static type = "survey";

}
